import { render, staticRenderFns } from "./ProposalInvitations.vue?vue&type=template&id=7a7571e4"
import script from "./ProposalInvitations.vue?vue&type=script&lang=js"
export * from "./ProposalInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports